// CART
export const ADD_PRODUCT_TO_CART = 'add_product_to_cart';
export const UPDATE_PRODUCT_CART = 'update_product_cart';
